import { NextResponse } from "next/server"

import { createSupabaseAdminClient } from "@/lib/supabase/admin"
import { createSupabaseServerClient } from "@/lib/supabase/server"

type FavoritePayload = {
  recipeId: string
}

export async function POST(request: Request) {
  try {
    const body = (await request.json()) as Partial<FavoritePayload>
    const recipeId = body.recipeId?.trim() ?? ""

    if (!recipeId) {
      return NextResponse.json(
        { ok: false, message: "Не передано recipeId." },
        { status: 400 }
      )
    }

    const supabaseServer = await createSupabaseServerClient()
    const {
      data: { user },
    } = await supabaseServer.auth.getUser()

    if (!user) {
      return NextResponse.json(
        { ok: false, message: "Потрібна авторизація." },
        { status: 401 }
      )
    }

    const supabase = createSupabaseAdminClient()

    const { data, error } = await supabase
      .from("saved_recipes")
      .upsert(
        {
          user_id: user.id,
          recipe_id: recipeId,
        },
        {
          onConflict: "user_id,recipe_id",
          ignoreDuplicates: true,
        }
      )
      .select("id, user_id, recipe_id, created_at")
      .single()

    if (error) {
      return NextResponse.json(
        { ok: false, message: error.message },
        { status: 500 }
      )
    }

    return NextResponse.json({
      ok: true,
      message: "Рецепт додано в збережені.",
      data,
    })
  } catch {
    return NextResponse.json(
      { ok: false, message: "Не вдалося зберегти рецепт." },
      { status: 500 }
    )
  }
}

export async function DELETE(request: Request) {
  try {
    const body = (await request.json()) as Partial<FavoritePayload>
    const recipeId = body.recipeId?.trim() ?? ""

    if (!recipeId) {
      return NextResponse.json(
        { ok: false, message: "Не передано recipeId." },
        { status: 400 }
      )
    }

    const supabaseServer = await createSupabaseServerClient()
    const {
      data: { user },
    } = await supabaseServer.auth.getUser()

    if (!user) {
      return NextResponse.json(
        { ok: false, message: "Потрібна авторизація." },
        { status: 401 }
      )
    }

    const supabase = createSupabaseAdminClient()

    const { error } = await supabase
      .from("saved_recipes")
      .delete()
      .eq("user_id", user.id)
      .eq("recipe_id", recipeId)

    if (error) {
      return NextResponse.json(
        { ok: false, message: error.message },
        { status: 500 }
      )
    }

    return NextResponse.json({
      ok: true,
      message: "Рецепт видалено зі збережених.",
    })
  } catch {
    return NextResponse.json(
      { ok: false, message: "Не вдалося видалити рецепт зі збережених." },
      { status: 500 }
    )
  }
}